import React from "react";
import { DragFileIcon, NoFileIcon } from "../../Icons";

const NoFiles = ({
  isDrag = false,
  primaryLabel = "No Files found",
  secondaryLabel = "Files will appear here once they’re added.",
  dragPrimaryText = "Drop files here",
}) => {
  return (
    <div className="flex flex-col justify-center items-center gap-2">
      {!isDrag ? (
        <>
          <NoFileIcon />
          <div className="flex flex-col justify-center items-center gap-1">
            <span className="text-[#232323] text-[1rem] font-medium">
              {primaryLabel}
            </span>
            <span className="font-normal text-[0.8rem] text-[#555555]">
              {secondaryLabel}
            </span>
          </div>
        </>
      ) : (
        <>
          <DragFileIcon />
          <div className="flex flex-col justify-center items-center gap-1">
            <span className="text-[#232323] text-[1rem] font-medium">
              {dragPrimaryText}
            </span>
            <span className="font-normal text-[0.8rem] text-[#555555]">
              or click <span className="text-[#0068FF]">New +</span> to upload
            </span>
          </div>{" "}
        </>
      )}
    </div>
  );
};

export default NoFiles;
